<!--component html goes here -->
<div class="d-inline-block rounded border border-light px-2 py-1" (click)="toggleSorting()">
  <i class="fa" [class.text-success]="isCurrentSortField()" [class.fa-arrow-up]="getNextSortDirection() === 'ASC'"
    [class.fa-arrow-down]="getNextSortDirection() === 'DESC'"></i>
</div>
